const sportClassesHelp = [
    {
        id: 1,
        text: "در این صفحه می توانید با توجه به نیاز خود، دوره مورد نظر را خریداری کنید"
    },
    {
        id: 2,
        text: "دوره هایی که زمان ثبت نام آنها به پایان زسیده است، تا زمان اعلام ثبت نام جدید قابل دسترسی نیستند"
    }
]

export default sportClassesHelp